export const LIST_NEW_BLOG = 'LIST_NEW_BLOG'
export const POST_INFO = 'POST_INFO'
export const LOADING_POST = 'LOADING_POST'